import { createFetchedData, LoadingState } from '@vista-digital/utilities';
import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { configurationSettings } from '../../../../../configuration/configuration-settings';
import { LoyaltyAuthenticationType } from '../../../../../configuration/types/loyalty/loyalty-authentication-type';
import { clearCxmData } from '../../../../browsing/actions/cxm/clear-cxm-data';
import { cancelOrder } from '../../../../order/actions/order/cancel-order';
import { salesDataDomainStore } from '../../../../sales-data';
import { loyaltyDomainStore } from '../../../store';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
import { clearIsMemberSignedInFromCookieInterval } from './update-is-member-signed-in-from-cookie';
/**
 * Sign out a loyalty member. This will either expire a cookie session or remove an [[AuthorizationToken]]
 * via the configured `setToken` callback depending on the [[LoyaltyAuthenticationConfig]].
 */
export const signMemberOut = async () => {
    const { onSignedOut, onSignedOutFailed } = configurationSettings.data.loyalty;
    try {
        await signOutApi();
    }
    catch (error) {
        const clearCookiesSucceeded = await (onSignedOutFailed === null || onSignedOutFailed === void 0 ? void 0 : onSignedOutFailed());
        if (!clearCookiesSucceeded) {
            throw error;
        }
    }
    temporaryLoyaltyDomainStore.reset();
    loyaltyDomainStore.reset();
    clearSubscriptionBillingOptions();
    cancelOrder();
    clearCxmData();
    // Clear the interval so onSignedOut is not called twice.
    clearIsMemberSignedInFromCookieInterval();
    onSignedOut === null || onSignedOut === void 0 ? void 0 : onSignedOut(false);
};
const signOutApi = async () => {
    const { authentication } = configurationSettings.data.loyalty;
    switch (authentication.type) {
        case LoyaltyAuthenticationType.Token: {
            return await authentication.setToken(undefined);
        }
        default: {
            return await ocapiClient.instance.v1.loyalty.members.authentication.expireCookie();
        }
    }
};
// TODO: Remove this temporary fix to force subscriptions to be reloaded after the loyalty domain has been reset. #300347
const clearSubscriptionBillingOptions = () => {
    runInAction(() => {
        salesDataDomainStore.data.subscriptionBillingOptionsById = createFetchedData(LoadingState.NotLoaded);
    });
};
//# sourceMappingURL=sign-member-out.js.map